<template>
  <div>
    <call-disposition />
  </div>
</template>

<script>
import CallDisposition from '@/components/CallDisposition'
export default {
  components: {
    CallDisposition
  },

  data: () => ({
    pageTitle: 'Call Summary Email',
    pageDescription:
      'Will capture any and all information about the caller and send you a summary via email or text after each call. Here is a sample of our email summary.'
  }),

  head() {
    return {
      title: this.pageTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageDescription
        }
      ]
    }
  }
}
</script>
